module.exports = __webpack_public_path__ + "img/logo_wcaworld1.7d05df88.webp";